import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency", "allCurrencies", "dropdown", "tempSelect", "currencyDisplay"]

  connect() {
    console.log('currency connect')
  }

  handleMoreCurrencies(event) {
    if (this.hasAllCurrenciesTarget && event.currentTarget.value === "more") {
      const defaultValueFromAll = this.allCurrenciesTarget.value
      const allCurrenciesValue = [...this.allCurrenciesTarget.children]
      this.currencyTargets.forEach(el => {
        el.replaceChildren(...allCurrenciesValue.map(el => el.cloneNode(true)))
        el.value = defaultValueFromAll
      })
      this.allCurrenciesTarget.remove()
      // Wartość osadzona programowo nie emituje "change" — bez `update` nasłuchujący zostaliby
      // przy stanie sprzed „więcej…", a formatka wysłałaby walutę, której nie pokazują.
      event.currentTarget.dispatchEvent(new Event("update"))
    } else {
      event.currentTarget.dispatchEvent(new Event("update"))
    }
  }

  update(event) {
    this.currencyDisplayTargets.forEach(el => { el.textContent = event.currentTarget.value })
    if (this.hasTempSelectTarget) this.tempSelectTarget.classList.add("hidden")
    if (this.hasDropdownTarget) this.dropdownTarget.classList.remove("hidden")
    this.currencyTargets.forEach(el => {
      if (el === event.currentTarget) return
      el.value = event.currentTarget.value
    })

    window.dispatchEvent(new CustomEvent("currency-changed", { detail: { currency: event.currentTarget.value } }))

    // show_if_currency_not_in_bank()
  }

  showSelectCurrency() {
    if (this.hasDropdownTarget && this.hasTempSelectTarget) {
      this.dropdownTarget.classList.add("hidden")
      this.tempSelectTarget.classList.remove("hidden")
    }
  }
}
